import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
    selector: '[appEnclosureBorder]',
    standalone: false
})
export class EnclosureBorderDirective implements OnInit {
  @Input() reference: HTMLDivElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.drawBorder();
    }, 0);
  }

  drawBorder() {
    this.renderer.setStyle(this.el.nativeElement, 'width', `${this.reference?.clientWidth + 2}px`);
    this.renderer.setStyle(this.el.nativeElement, 'height', `${this.reference?.clientHeight + 1}px`);
  }
}
